export default __webpack_public_path__ + "static/media/14.7388aa86.png";